export class DefaultLogic {
    ctaButtonText(args = {}) {
        const defaultText = 'Visit Site';
        const unavailableText = 'Currently Unavailable';

        const { partner, host } = args;

        if (!this.isActivePartner(args)) {
            return unavailableText;
        }

        if (partner?.cta_button_text) {
            return partner.cta_button_text;
        }

        if (host?.partner_cta_text) {
            return host?.partner_cta_text;
        }

        return defaultText;
    }

    isActivePartner(args) {
        const { partner } = args;

        if (this.disableDuolingo(args)) {
            return false;
        }

        const isPartnerDisabled =
            partner?.marketing_properties?.partner_active === 'no';
        if (isPartnerDisabled) {
            return false;
        }

        return true;
    }

    disableDuolingo(args) {
        const { partner, host } = args;
        const isDuoLingo = partner?.clicked_partner_name === 'duo-lingo';
        const isDuoLingoDisabledAtHost = Boolean(host?.duolingo_inactive);

        return isDuoLingoDisabledAtHost && isDuoLingo;
    }

    getColors() {
        return {
            primary: '#F55A4A',
            secondary: '#A2C738',
            background: '#FDF3F3',
            accent: '#439DFF',
        };
    }
}
